export const CustomizationStyle = {
  mainWrapper: {
    display: 'flex',
    gap: '20px',
    height: 'calc(100vh - 128px)',
  },
  leftBoxWrapper: {
    position: 'relative',
    width: '50%',
    background: 'var(--default-white)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    boxShadow: 'var(--box-shadow--1)',
  },
  heading: {
    width: '100%',
    px: '24px',
    py: '12px',
    borderBottom: '1px solid var(--neutral-100)',
    fontWeight: '700',
    color: 'var(--neutral-900)',
  },
  checkBoxContainer: {padding: '16px 24px 24px 24px'},
  logoText: {color: 'var(--neutral-200)', fontSize: '12px', mt: '12px'},
  buttonsBlock: {display: 'flex', gap: '24px', p: '24px', borderTop: '1px solid var(--neutral-100)'},
  rightBoxWrapper: {
    width: '50%',
    background: 'var(--default-white)',
    borderRadius: '8px',
    height: '100%',
    boxShadow: 'var(--box-shadow--1)',
    position: 'relative',
  },
  rightHeading: {
    width: '100%',
    px: '24px',
    py: '12px',
    borderBottom: '1px solid var(--neutral-100)',
    fontWeight: '700',
    color: 'var(--neutral-900)',
  },
  sceletonWrapper: {
    width: '100%',
    minHeight: '90%',
    bgcolor: '#f1f2f5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    py: 4,
  },
  sceletonBox: {
    bgcolor: 'white',
    width: 360,
    height: 640,
    px: 3,
    py: 4,
    boxShadow: 3,
    borderRadius: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'relative',
  },
  inputs: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '16px 24px',
    height: 'calc(100vh - 270px)',
    overflowY: 'auto',
  },
  logoPosition: {position: 'absolute', top: '16px', left: '16px'},
  logoPositionText: {fontWeight: 400, fontSize: '12px', lineHeight: '20px'},
  flexGap: {display: 'flex', gap: 2},
  headingRight: {px: '24px', py: '16px', display: 'flex', flexDirection: 'column', gap: 1},
  eventLogoRight: {width: '100%', marginBottom: '10px', height: '200px'},
  emailContent: {
    width: '100%',
    height: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#0C152533',
    mb: '24px',
  },
  linkCont: {
    display: 'flex',
    gap: 2,
    justifyContent: 'center',
    mb: '24px',
  },
  linkItem: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    border: '1px solid',
    borderColor: '#ddd',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  textarea: '276px',
  mainBoxWrapper: {
    p: '24px',
    height: ' calc(100vh - 268px)',
    overflowY: 'auto',
  },
  rightLogoWrapper: {display: 'flex', justifyContent: 'center'},
  rightLogo: {maxWidth: '100%', marginBottom: '10px', height: '48px', marginTop: '10px'},
  rightTitle: {
    fontWeight: '700',
    fontSize: '20px',
    letterSpacing: '0.15px',
    padding: '0px 24px 16px 24px',
  },
  rightMessage: {
    padding: '0px 24px 16px 24px',
    whiteSpace: 'pre-line',
  },
  topBtn: {marginBottom: '16px'},
  pdfContainer: {px: '40px', display: 'flex', pb: '30px', justifyContent: 'space-between'},

  sponsorHeading: {
    textAlign: 'center',
    marginTop: '12px',
    marginBottom: '12px',
  },

  sponsorWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px',
  },

  button: {
    marginRight: 'auto',
  },

  iconsWrapper: {
    display: 'flex',
    gap: '16px',
    marginTop: '24px',
    padding: '24px 76px',
  },

  icon: {
    width: '44px',
    height: '44px',
    cursor: 'pointer',
    border: '1px solid var(--neutral-100)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      width: '24px',
      height: '24px',
    },
  },

  sponsorName: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    borderRadius: '0px 0px 8px 8px',
    boxShadow: 'var(--box-shadow--1)',
  },

  sponsorImage: {
    maxHeight: '104px',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px 8px 0 0',

    '& img': {
      objectFit: 'cover',
      height: '100%',
      width: '100%',
    },
  },

  sponsorItem: {
    boxShadow: 'var(--box-shadow--1)',
  },

  sponsorList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    marginBottom: '24px',
    gap: '16px',
  },

  codeWrapper: {
    width: '168px',
    height: '296px',
    background: '#026C96',
    borderRadius: '8px',
    padding: '24px',
    margin: '0 auto',
    marginBottom: '24px',
  },

  codeLogo: {
    width: '64px',
    height: '48px',
    margin: '0 auto',

    // objectFit: 'contain',
    marginBottom: '16px',
  },

  codeText: {
    color: 'var(--default-white)',
    fontSize: '14px',
    // marginBottom: '8px',
    display: 'flex',
    justifyContent: 'center',
  },

  codeTitle: {
    color: 'var(--default-white)',
    fontSize: '20px',
    fontWeight: '700',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '12px',
  },
};
